export default __webpack_public_path__ + "static/ciaodarlogotransp-ccac6fb818fe4b5988063ecb09e2ac98.png";